import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e91b076"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "pages" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "socials" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "copy" }

import { computed, inject } from 'vue'

import { useContent } from '@/composables/content'
import { ModalWrapper, useModal } from '@/composables/general'
import { useStore } from '@/store'
import Story from '@/models/Story'


export default /*#__PURE__*/_defineComponent({
  __name: 'Pages',
  props: { blok: Object },
  setup(__props) {



const { pages } = useContent()
const store = useStore()
const subpages = computed(() => {
  return pages.value.filter((page) => !page.is_startpage)
})

const modalWrapper = inject(ModalWrapper)!
const openModal = (story: typeof Story) => useModal(story, modalWrapper)

const socials = computed(() => store.config.socials)
const web = computed(() => store.config.web)

return (_ctx: any,_cache: any) => {
  const _component_IonIcon = _resolveComponent("IonIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subpages), (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "item",
          onClick: ($event: any) => (openModal(item))
        }, [
          _createElementVNode("h3", null, _toDisplayString(item.title), 1)
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(socials), (item, i) => {
        return (_openBlock(), _createElementBlock("a", {
          key: i,
          href: item.link
        }, [
          _createVNode(_component_IonIcon, {
            class: "icon",
            size: "large",
            src: `/assets/icon/${item.icon}.svg`
          }, null, 8, ["src"])
        ], 8, _hoisted_5))
      }), 128))
    ]),
    (_unref(web))
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "link",
          href: `http://${_unref(web)}`
        }, _toDisplayString(_unref(web)), 9, _hoisted_6))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, "© " + _toDisplayString(new Date().getFullYear()), 1)
  ]))
}
}

})